"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAROUSEL_DOCUMENTS_QUERY = void 0;
const client_1 = require("@apollo/client");
exports.CAROUSEL_DOCUMENTS_QUERY = (0, client_1.gql) `
  query getCarouselDocuments($objectId: ID!, $objectType: ObjectType!) {
    getDocumentUploadsForTargetObject(
      objectId: $objectId
      objectType: $objectType
      filterProcessing: true
      carouselDocumentsOnly: true
    ) {
      id
      accountDocumentType {
        id
        name
      }
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0Q2Fyb3VzZWxEb2N1bWVudHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9jb21wb25lbnRzL0NvbW1vbi9DYXJvdXNlbC9fX3F1ZXJpZXNfXy9nZXRDYXJvdXNlbERvY3VtZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSwyQ0FBcUM7QUFFeEIsUUFBQSx3QkFBd0IsR0FBRyxJQUFBLFlBQUcsRUFBQTs7Ozs7Ozs7Ozs7Ozs7O0NBZTFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBncWwgfSBmcm9tIFwiQGFwb2xsby9jbGllbnRcIjtcblxuZXhwb3J0IGNvbnN0IENBUk9VU0VMX0RPQ1VNRU5UU19RVUVSWSA9IGdxbGBcbiAgcXVlcnkgZ2V0Q2Fyb3VzZWxEb2N1bWVudHMoJG9iamVjdElkOiBJRCEsICRvYmplY3RUeXBlOiBPYmplY3RUeXBlISkge1xuICAgIGdldERvY3VtZW50VXBsb2Fkc0ZvclRhcmdldE9iamVjdChcbiAgICAgIG9iamVjdElkOiAkb2JqZWN0SWRcbiAgICAgIG9iamVjdFR5cGU6ICRvYmplY3RUeXBlXG4gICAgICBmaWx0ZXJQcm9jZXNzaW5nOiB0cnVlXG4gICAgICBjYXJvdXNlbERvY3VtZW50c09ubHk6IHRydWVcbiAgICApIHtcbiAgICAgIGlkXG4gICAgICBhY2NvdW50RG9jdW1lbnRUeXBlIHtcbiAgICAgICAgaWRcbiAgICAgICAgbmFtZVxuICAgICAgfVxuICAgIH1cbiAgfVxuYDtcbiJdfQ==